import {useState, useEffect} from 'react';

/** Grupo de permisos tal como viene en el usuario guardado en localStorage. */
export interface PermissionGroup {
    name: string;
    permissions: string[];
}

export interface UserIdentity {
    id: number;
    email: string;
    name: string;
    surname: string;
}

export interface UserSetting {
    currency?: { symbol: string; prefix: string };
    currencySystem?: { symbol: string; prefix: string };
    /** Marca si el usuario todavia no vio la pantalla de People & Culture. */
    viewPeopleCultureStart?: boolean;
}

/** Payload completo del usuario en localStorage: identidad + token + permisos + settings. */
interface StoredUser extends UserIdentity {
    token: string;
    permissions: PermissionGroup[];
    userSetting: UserSetting;
}

export const useUserData = () => {
    const [user, setUser] = useState<UserIdentity | null>(null);
    const [token, setToken] = useState<string | null>(null);
    const [userSetting, setUserSetting] = useState<UserSetting | null>(null)
    const [permissions, setPermissions] = useState<PermissionGroup[] | null>(null)

    useEffect(() => {
        let userLocal = localStorage.getItem("user")
        if (userLocal !== "" && userLocal !== null) {
            let user = JSON.parse(userLocal) as StoredUser
            let {id, email, name, surname, token, permissions, userSetting} = user;
            setToken(token)
            setUser({
                id,
                email,
                name,
                surname
            })
            setPermissions(permissions)
            setUserSetting(userSetting)
        }
    }, []);

    return {user, token,permissions, userSetting};
}
